/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Macro_CarbsInputs */

const en_platform_macro_carbs = /** @type {(inputs: Platform_Macro_CarbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carbs`)
};

const pl_platform_macro_carbs = /** @type {(inputs: Platform_Macro_CarbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Węglowodany`)
};

/**
* | output |
* | --- |
* | "Carbs" |
*
* @param {Platform_Macro_CarbsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_macro_carbs = /** @type {((inputs?: Platform_Macro_CarbsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Macro_CarbsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_macro_carbs(inputs)
	return en_platform_macro_carbs(inputs)
});